import { render, staticRenderFns } from "./ReuseStar.vue?vue&type=template&id=ecbed282&scoped=true"
import script from "./ReuseStar.vue?vue&type=script&lang=js"
export * from "./ReuseStar.vue?vue&type=script&lang=js"
import style0 from "./ReuseStar.vue?vue&type=style&index=0&id=ecbed282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbed282",
  null
  
)

export default component.exports